<template>
  <div class="alert-management alert-management-page">
    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-item">
        <label class="filter-label date-label">告警时间</label>
        <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始时间"
          end-placeholder="结束时间" value-format="YYYY-MM-DD" :disabled-date="disabledDate" :clearable="false"
          class="filter-date-picker" @change="handleDateChange" />
      </div>
      <div class="filter-item">
        <label class="filter-label">设备类型</label>
        <v-select v-model="filterDevice" :items="deviceOptions" placeholder="全部" variant="outlined" density="compact"
          class="filter-select" :menu-props="{ contentClass: 'alert-management-filter-select-menu' }"
          active-class="filter-select-active" />
      </div>
      <div class="filter-item">
        <label class="filter-label">告警描述</label>
        <v-text-field v-model="filterDescription" placeholder="请输入告警描述" variant="outlined" density="compact"
          class="filter-input" clearable />
      </div>
      <div class="filter-actions">
        <v-btn :variant="hasAdvancedFilters ? 'flat' : 'outlined'" color="#2655f1" rounded="xl"
          :class="['action-btn', { 'action-btn--active': hasAdvancedFilters }]" @click="openAdvancedFilterDialog">
          <v-icon start icon="mdi-filter-variant" />筛选
        </v-btn>
        <v-btn color="#2655f1" rounded="xl" class="action-btn" @click="handleSearch">
          <v-icon start icon="mdi-magnify" />查询
        </v-btn>
        <v-btn variant="outlined" color="#2655f1" rounded="xl" class="action-btn" :disabled="!canExportAlarmInfo"
          @click="handleExport">
          <v-icon start icon="mdi-download" />导出
        </v-btn>
        <v-btn variant="outlined" color="#2655f1" rounded="xl" class="action-btn" @click="handleReset">
          <v-icon start icon="mdi-refresh" />重置
        </v-btn>
      </div>
    </div>

    <!-- 高级筛选弹窗 -->
    <v-dialog v-model="advancedFilterDialogVisible" class="advanced-filter-dialog gm-dialog" max-width="420"
      scrim="rgba(15, 23, 42, 0.24)" transition="slide-x-reverse-transition">
      <v-card class="advanced-filter-card overflow-hidden">
        <div class="advanced-filter-header d-flex align-center px-8 py-6">
          <div class="text-h5"><span style="color: #2655f1">筛选</span><span>条件</span></div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="closeAdvancedFilterDialog" />
        </div>

        <div class="advanced-filter-body px-8 pt-4 pb-2">
          <div class="advanced-filter-item">
            <div class="advanced-filter-label">告警等级</div>
            <v-select v-model="advancedFilterDraft.level" :items="levelOptions" placeholder="全部" variant="outlined"
              density="compact" hide-details rounded="xl" class="gm-input"
              :menu-props="{ contentClass: 'alert-management-filter-select-menu' }"
              active-class="filter-select-active" />
          </div>
          <div class="advanced-filter-item">
            <div class="advanced-filter-label">告警状态</div>
            <v-select v-model="advancedFilterDraft.status" :items="statusOptions" placeholder="全部" variant="outlined"
              density="compact" hide-details rounded="xl" class="gm-input"
              :menu-props="{ contentClass: 'alert-management-filter-select-menu' }"
              active-class="filter-select-active" />
          </div>
          <div class="advanced-filter-item">
            <div class="advanced-filter-label">设备编码</div>
            <v-text-field v-model="advancedFilterDraft.uuid" placeholder="请输入设备编码" variant="outlined" density="compact"
              hide-details clearable rounded="xl" class="gm-input" @keyup.enter="applyAdvancedFilters" />
          </div>
          <div class="advanced-filter-item">
            <div class="advanced-filter-label">告警编码</div>
            <v-text-field v-model="advancedFilterDraft.alarmCode" placeholder="请输入告警编码" variant="outlined"
              density="compact" hide-details clearable rounded="xl" class="gm-input"
              @keyup.enter="applyAdvancedFilters" />
          </div>
          <div class="advanced-filter-item">
            <div class="advanced-filter-label">故障编码</div>
            <v-text-field v-model="advancedFilterDraft.code" placeholder="请输入故障编码" variant="outlined" density="compact"
              hide-details clearable rounded="xl" class="gm-input" @keyup.enter="applyAdvancedFilters" />
          </div>
        </div>

        <div class="advanced-filter-actions px-8 pb-8 pt-0 justify-end">
          <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4" @click="resetAdvancedFiltersOnly">
            重置筛选
          </v-btn>
          <v-btn color="#2655f1" variant="flat" class="gm-btn-primary px-10 text-white" @click="applyAdvancedFilters">
            确定
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- 告警列表表格 -->
    <div class="alert-table-outer" v-loading="loading">
      <div class="table-scroll">
        <v-table class="gm-table bg-transparent border-none pm-table-sticky" density="comfortable" fixed-header>
          <thead>
            <tr>
              <th style="min-width: 140px">设备名称</th>
              <th style="min-width: 200px">设备UUID</th>
              <th style="min-width: 100px">设备类型</th>
              <th style="min-width: 110px">告警编码</th>
              <th style="min-width: 110px">故障编码</th>
              <th style="min-width: 100px">告警等级</th>
              <th style="min-width: 180px">告警描述</th>
              <th style="min-width: 200px">告警状态</th>
              <th style="min-width: 170px">开始时间</th>
              <th style="min-width: 170px">结束时间</th>
              <th style="min-width: 90px">触发次数</th>
              <th style="min-width: 90px">恢复次数</th>
              <th style="min-width: 90px">值</th>
              <th style="min-width: 140px">备注</th>
              <!-- <th style="min-width: 120px">操作</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in alertList" :key="item.id">
              <td>{{ item.deviceName }}</td>
              <td>
                <div class="uuid-cell">
                  <span class="uuid-text" :title="item.deviceVid || ''">{{ item.deviceVid || '--' }}</span>
                  <v-btn v-if="String(item.deviceVid ?? '').trim()" icon size="x-small" variant="text" color="#2655f1"
                    class="uuid-copy-btn" aria-label="复制设备UUID" @click.stop="copyDeviceUuid(item.deviceVid)">
                    <v-icon size="16">mdi-content-copy</v-icon>
                  </v-btn>
                </div>
              </td>
              <td>{{ getDeviceTypeText(item.deviceType) }}</td>
              <td>{{ item.alarmCode }}</td>
              <td>{{ item.code }}</td>
              <td>{{ getLevelText(item.alarmLevel) }}</td>
              <td>{{ item.alarmDescription }}</td>
              <td>
                <div class="status-cell">
                  <span :class="{
                    'status-transferred': item.status === 4 || item.status === 5,
                    'status-unrecovered': item.status === 1,
                    'status-confirmed': item.status === 3
                  }">{{ getStatusText(item.status) }}</span>
                  <v-btn v-if="item.status === 1" variant="text" color="#2655f1" rounded="xl" size="small"
                    class="status-confirm-btn" @click="openManualConfirm(item)">
                    人工确认
                  </v-btn>
                </div>
              </td>
              <td>{{ item.startTime || '--' }}</td>
              <td>{{ item.endTime && item.endTime !== '/' ? item.endTime : '--' }}</td>
              <td>{{ item.triggerCount ?? '--' }}</td>
              <td>{{ item.recoveryCount ?? '--' }}</td>
              <td>
                <el-tooltip
                  :content="displayCellValue(item.value)"
                  placement="top"
                  :disabled="!isCellValueLong(item.value)"
                  popper-class="alert-value-tooltip"
                >
                  <span class="value-cell">{{ displayCellValue(item.value) }}</span>
                </el-tooltip>
              </td>
              <td>
                <el-tooltip
                  :content="displayCellValue(item.remark)"
                  placement="top"
                  :disabled="!isCellValueLong(item.remark)"
                  popper-class="alert-value-tooltip"
                >
                  <span class="value-cell">{{ item.remark || '--' }}</span>
                </el-tooltip>
              </td>
              <td>
                <!-- <v-btn size="small" variant="flat" color="primary" class="analysis-btn"
                  @click="openAnalysisPanel(item)">
                  <span class="vip-badge">VIP</span>
                  智能分析
                </v-btn> -->
              </td>
            </tr>
            <tr v-if="!alertList.length">
              <td colspan="15" class="text-center text-medium-emphasis py-8">暂无数据</td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </div>

    <TablePagination v-model="pagination.current" :page-size="pagination.pageSize" :total="pagination.total"
      :has-sizes="false" :has-jump="false" :has-info="false" @change="handlePaginationChange" />

    <!-- 人工确认弹窗 -->
    <v-dialog v-model="confirmDialogVisible" max-width="420px" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-6">
          <div class="text-h5">
            <span style="color: #2655f1">人工</span><span>确认</span>
          </div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="closeManualConfirm" />
        </div>
        <v-card-text class="pa-8 pt-2 pb-4">
          <div class="text-body-1">确认该告警吗？</div>
        </v-card-text>
        <v-card-actions class="px-8 pb-8 pt-0 justify-end">
          <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
            @click="closeManualConfirm">取消</v-btn>
          <v-btn color="#2655f1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="confirmLoading"
            @click="doManualConfirm">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 智能分析面板 -->
    <AlarmAnalysisPanel v-model="showAnalysisPanel" :alarm-data="selectedAlarm" :station-id="String(stationId || '')"
      :station-name="stationBaseData?.name" @jump-to-agent="handleJumpToAgent" />
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue'
import dayjs from 'dayjs'
import { getAlertList, exportAlertList, manualResetAlarm } from '@/api/alert'
import { eui } from 'ems-ui'
import { useStationContext } from '../composables/useStationContext'
import { checkPermi } from '@/utils/permission'
import { copyText } from '@/utils'
import TablePagination from '@/components/TablePagination/index.vue'
import AlarmAnalysisPanel from './AlertManagement/AlarmAnalysisPanel.vue'
import {
  deviceTypeOptions,
  alarmLevelOptions,
  getDeviceTypeText,
  getAlarmLevelText,
  getAlarmStateText
} from '../dicts/alert'

// 使用 provide/inject 获取电站信息
const { stationId } = useStationContext()
const props = defineProps({
  baseData: {
    type: Object,
    default: () => ({})
  }
})
const stationBaseData = computed(() => props.baseData)
const canExportAlarmInfo = computed(() => checkPermi(['ops:alarmInfo:export']))

// 筛选条件
const filterDevice = ref('')
const filterDescription = ref('')
const filterLevel = ref('')
const filterStatus = ref('')
const uuid = ref('')
const alarmCode = ref('')
const code = ref('')
// 日期范围（Element Plus 格式：['YYYY-MM-DD', 'YYYY-MM-DD']）
const dateRange = ref([])
const dateRangeStart = ref('')
const dateRangeEnd = ref('')

// 高级筛选弹窗
const advancedFilterDialogVisible = ref(false)
const advancedFilterDraft = reactive({
  level: '',
  status: '',
  uuid: '',
  alarmCode: '',
  code: '',
})

const hasAdvancedFilters = computed(() => {
  return Boolean(uuid.value || alarmCode.value || code.value) ||
    (filterLevel.value !== '' && filterLevel.value != null) ||
    (filterStatus.value !== '' && filterStatus.value != null)
})

function syncAdvancedFilterDraft() {
  advancedFilterDraft.level = filterLevel.value
  advancedFilterDraft.status = filterStatus.value
  advancedFilterDraft.uuid = uuid.value
  advancedFilterDraft.alarmCode = alarmCode.value
  advancedFilterDraft.code = code.value
}

function openAdvancedFilterDialog() {
  syncAdvancedFilterDraft()
  advancedFilterDialogVisible.value = true
}

function closeAdvancedFilterDialog() {
  advancedFilterDialogVisible.value = false
}

function applyAdvancedFilters() {
  filterLevel.value = advancedFilterDraft.level ?? ''
  filterStatus.value = advancedFilterDraft.status ?? ''
  uuid.value = (advancedFilterDraft.uuid || '').trim()
  alarmCode.value = (advancedFilterDraft.alarmCode || '').trim()
  code.value = (advancedFilterDraft.code || '').trim()
  closeAdvancedFilterDialog()
  handleSearch()
}

function resetAdvancedFiltersOnly() {
  advancedFilterDraft.level = ''
  advancedFilterDraft.status = ''
  advancedFilterDraft.uuid = ''
  advancedFilterDraft.alarmCode = ''
  advancedFilterDraft.code = ''
}

// 设置日期的禁选范围（半年前到今天）
function disabledDate(date) {
  const today = dayjs()
  const sixMonthsAgo = today.subtract(6, 'month')
  return dayjs(date) > today || dayjs(date) < sixMonthsAgo
}

// 处理日期范围变化
function handleDateChange(value) {
  if (value && Array.isArray(value) && value.length === 2) {
    dateRangeStart.value = `${value[0]}T00:00`
    dateRangeEnd.value = `${value[1]}T23:59`
  } else {
    dateRangeStart.value = ''
    dateRangeEnd.value = ''
  }
}

// 列表数据
const alertList = ref([])
const loading = ref(false)

// 分页
const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0
})

// 选项数据（使用字典）
const deviceOptions = deviceTypeOptions
const levelOptions = alarmLevelOptions
// 告警状态选项（只包含全部、未处理-1、自动恢复-2、人工确认-3）
const statusOptions = [
  { title: '全部', value: '' },
  { title: '未处理', value: 1 },
  { title: '自动恢复', value: 2 },
  { title: '人工确认', value: 3 }
]

// 格式化日期时间为API需要的格式 (YYYY-MM-DD HH:mm:ss)
const formatDateTimeForAPI = (dateTimeString) => {
  if (!dateTimeString) return undefined
  // 如果是 datetime-local 格式 (YYYY-MM-DDTHH:mm)，转换为 YYYY-MM-DD HH:mm:ss
  if (dateTimeString.includes('T')) {
    return dateTimeString.replace('T', ' ') + ':00'
  }
  // 如果已经是 YYYY-MM-DD HH:mm 格式，添加秒
  if (dateTimeString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/)) {
    return dateTimeString + ':00'
  }
  return dateTimeString
}

// 获取告警列表
const fetchAlertList = async () => {
  loading.value = true
  try {
    // 准备API参数
    const params = {
      pageNum: pagination.value.current,
      pageSize: pagination.value.pageSize
    }

    // 添加筛选条件
    if (dateRangeStart.value) {
      const formatted = formatDateTimeForAPI(dateRangeStart.value)
      params.startTime = formatted ? formatted.replace(/:\d{2}$/, ':00') : undefined
    }
    if (dateRangeEnd.value) {
      const formatted = formatDateTimeForAPI(dateRangeEnd.value)
      params.endTime = formatted ? formatted.replace(/:\d{2}$/, ':59') : undefined
    }
    if (stationId.value) {
      params.stationId = stationId.value
    }
    if (filterDevice.value) {
      params.type = filterDevice.value
    }
    // 告警等级：需要支持0值（提示等级）
    if (filterLevel.value !== '' && filterLevel.value != null) {
      params.level = Number(filterLevel.value)
    }
    if (filterDescription.value) {
      params.description = filterDescription.value
    }
    // 告警状态：需要支持可能的0值
    if (filterStatus.value !== '' && filterStatus.value != null) {
      params.state = Number(filterStatus.value)
    }
    if (uuid.value) {
      params.uuid = uuid.value
    }
    if (alarmCode.value) {
      params.alarmCode = alarmCode.value
    }
    if (code.value) {
      params.code = code.value
    }

    // 调用API
    const result = await getAlertList(params)

    // 处理返回数据
    const records = result?.rows || []
    const total = result?.total || 0

    // 映射API返回的数据格式到表格需要的格式
    alertList.value = records.map((item) => ({
      id: item.id,
      deviceName: item.equipmentName || '',
      deviceVid: item.uuid || '',
      deviceType: item.type || '',
      alarmCode: item.alarmCode || '',
      code: item.code || '',
      alarmLevel: item.level,
      alarmDescription: item.description || '',
      startTime: item.startTime || '',
      endTime: item.endTime || '/',
      triggerCount: item.triggerCount || 0,
      recoveryCount: item.recoveryCount || 0,
      value: item.value || '',
      confirmTime: item.checkTime || '',
      status: item.state,
      remark: item.remark || '',
      moduleType: item.moduleType,
      lastTime: item.lastTime || '',
      tags: item.tags || []
    }))

    pagination.value.total = total
  } catch (error) {
    console.error('获取告警列表失败:', error)
    alertList.value = []
    pagination.value.total = 0
  } finally {
    loading.value = false
  }
}

// 查询
const handleSearch = () => {
  // 重置分页到第一页
  pagination.value.current = 1
  fetchAlertList()
}

// 重置
const handleReset = () => {
  // 重置筛选条件为初始状态
  filterDevice.value = ''
  filterDescription.value = ''
  filterLevel.value = ''
  filterStatus.value = ''
  uuid.value = ''
  alarmCode.value = ''
  code.value = ''

  // 重置日期为今天（初始状态）
  const today = dayjs()
  const todayStr = today.format('YYYY-MM-DD')
  dateRange.value = [todayStr, todayStr]
  dateRangeStart.value = `${todayStr}T00:00`
  dateRangeEnd.value = `${todayStr}T23:59`

  // 重置分页
  pagination.value.current = 1

  // 重新查询
  fetchAlertList()
}

const buildExportParams = () => {
  const params = {}

  if (dateRangeStart.value) {
    const formatted = formatDateTimeForAPI(dateRangeStart.value)
    params.startTime = formatted ? formatted.replace(/:\d{2}$/, ':00') : undefined
  }
  if (dateRangeEnd.value) {
    const formatted = formatDateTimeForAPI(dateRangeEnd.value)
    params.endTime = formatted ? formatted.replace(/:\d{2}$/, ':59') : undefined
  }
  if (stationId.value) {
    params.stationId = stationId.value
  }
  if (filterDevice.value) {
    params.type = filterDevice.value
  }
  // 告警等级：需要支持0值（提示等级）
  if (filterLevel.value != null && filterLevel.value !== '') {
    params.level = Number(filterLevel.value)
  }
  if (filterDescription.value) {
    params.description = filterDescription.value
  }
  if (filterStatus.value !== '' && filterStatus.value !== undefined && filterStatus.value !== null) {
    // state 需要支持0值
    params.state = Number(filterStatus.value)
  }
  if (uuid.value) {
    params.uuid = uuid.value
  }
  if (alarmCode.value) {
    params.alarmCode = alarmCode.value
  }
  if (code.value) {
    params.code = code.value
  }

  return params
}

// 导出
const handleExport = async () => {
  if (!canExportAlarmInfo.value) return
  try {
    // 构建导出参数
    const params = buildExportParams()

    // 调用导出接口
    const blob = await exportAlertList(params)

    // 创建下载链接
    const url = window.URL.createObjectURL(new Blob([blob]))
    const link = document.createElement('a')
    link.href = url

    // 生成文件名（包含时间戳）
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19)
    link.setAttribute('download', `告警列表_${timestamp}.xlsx`)

    // 触发下载
    document.body.appendChild(link)
    link.click()

    // 清理
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('导出告警列表失败:', error)
  }
}

// 获取等级文本（使用字典）
const getLevelText = getAlarmLevelText

// 获取状态文本（使用字典）
const getStatusText = getAlarmStateText

const handlePaginationChange = () => {
  fetchAlertList()
}

// 值/备注单元格：空值显示占位，超长文本省略号 + 悬停查看完整内容
const displayCellValue = (val) => (val !== '' && val != null ? String(val) : '--')
const CELL_VALUE_ELLIPSIS_THRESHOLD = 18
const isCellValueLong = (val) => displayCellValue(val).length > CELL_VALUE_ELLIPSIS_THRESHOLD

// 告警智能分析
const showAnalysisPanel = ref(false)
const selectedAlarm = ref(null)

const openAnalysisPanel = (alarm) => {
  selectedAlarm.value = {
    alarmId: alarm.id,
    equipmentName: alarm.deviceName,
    uuid: alarm.deviceVid,
    alarmCode: alarm.alarmCode,
    description: alarm.alarmDescription,
    level: alarm.alarmLevel,
    moduleType: alarm.moduleType,
    state: alarm.status,
    startTime: alarm.startTime,
    endTime: alarm.endTime,
    lastTime: alarm.lastTime,
    triggerCount: alarm.triggerCount,
    value: alarm.value,
    tags: alarm.tags
  }
  showAnalysisPanel.value = true
}

const handleJumpToAgent = (context) => {
  console.log('跳转到智能体，携带上下文:', context)
}

// 人工确认告警
const confirmDialogVisible = ref(false)
const confirmTargetId = ref(null)
const confirmLoading = ref(false)

const openManualConfirm = (item) => {
  if (!item?.id) return
  confirmTargetId.value = item.id
  confirmDialogVisible.value = true
}

const closeManualConfirm = () => {
  if (confirmLoading.value) return
  confirmDialogVisible.value = false
  confirmTargetId.value = null
}

/** 复制设备UUID到剪贴板 */
async function copyDeviceUuid(text) {
  const s = String(text ?? '').trim()
  if (!s) {
    eui.showToast('暂无可复制内容', 'info')
    return
  }
  try {
    await navigator.clipboard.writeText(s)
    eui.showToast('已复制到剪贴板', 'success')
  } catch {
    // 非 HTTPS / 不支持 Clipboard API 时降级
    if (copyText(s)) {
      eui.showToast('已复制到剪贴板', 'success')
    } else {
      eui.showToast('复制失败，请手动选择文本复制', 'error')
    }
  }
}

const doManualConfirm = async () => {
  if (!confirmTargetId.value) return
  confirmLoading.value = true
  try {
    const res = await manualResetAlarm(confirmTargetId.value)
    if (res?.code === 200) {
      eui.showToast('人工确认成功', 'success')
      confirmDialogVisible.value = false
      confirmTargetId.value = null
      fetchAlertList()
    } else {
      eui.showToast(res?.msg || '人工确认失败', 'error')
    }
  } catch (error) {
    console.error('人工确认失败:', error)
    eui.showToast('人工确认失败', 'error')
  } finally {
    confirmLoading.value = false
  }
}

onMounted(() => {
  // 初始化日期为今天
  const today = dayjs()
  const todayStr = today.format('YYYY-MM-DD')
  dateRange.value = [todayStr, todayStr]
  dateRangeStart.value = `${todayStr}T00:00`
  dateRangeEnd.value = `${todayStr}T23:59`

  if (stationId.value) {
    fetchAlertList()
  }
})

watch(() => stationId.value, () => {
  fetchAlertList()
})
</script>

<style scoped lang="scss">
.alert-management {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
  gap: 0;
  padding: 0;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.alert-management-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.filter-bar {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
  padding: 16px 24px;
  background: #fff;
  flex-shrink: 0;
  flex-wrap: wrap;
  min-height: 72px;

  :deep(.v-select__selection-text) {
    max-width: 132px;
  }

  // 每行显示5个查询条件
  .filter-item {
    flex: 0 0 calc((100% - 48px) / 5);
    max-width: calc((100% - 48px) / 5);
    min-width: 200px;
  }

  .filter-actions {
    flex: 0 0 auto;
    margin-left: auto;
  }
}

:deep(.mdi-menu-down) {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  color: #2E2E2E !important;
  opacity: 0.22;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 1;
  min-width: 0;
  height: 40px;
}

.filter-label {
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #2e2e2e;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}

.filter-label.date-label {
  color: #2E2E2E;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.filter-date-picker {
  flex: 1 1 0;
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;

  :deep(.el-input__wrapper) {
    width: 100% !important;
    max-width: 100% !important;
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    padding: 0 16px;
    min-height: 40px;
    height: 40px;
    transition: border-color 0.2s;

    &.is-focus {
      border-color: #3a68ff;
    }
  }

  :deep(.el-input__inner) {
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    height: 40px;
    line-height: 40px;

    &::placeholder {
      color: rgba(46, 46, 46, 0.5);
      font-weight: 400;
      font-family: "HarmonyOS Sans SC", sans-serif;
    }
  }

  :deep(.el-input__suffix) {
    color: rgba(46, 46, 46, 0.5);
  }
}

:deep(.el-range-editor) {
  background: #fff;
  border: 1px solid #9e9e9e;
  border-radius: 20px;
  align-items: center;
  margin: 0;
  display: flex;
  box-shadow: 0 1px 2px #0000000d;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
}

:deep(.el-range-editor:focus-within) {
  border-color: var(--color-primary);
}

:deep(.el-date-editor) {
  .el-range__close-icon {
    display: none !important;
  }
}

// 选中日期时的颜色
:deep(.el-date-editor.el-input__wrapper:hover) {
  box-shadow: none !important;
}

.filter-select {
  flex: 1 1 0;
  width: 100%;
  min-width: 0;
  max-width: 100%;

  :deep(.v-field) {
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    display: flex;
    align-items: center;
    margin: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  :deep(.v-field__input) {
    padding: 8px 0px 8px 16px;
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    display: flex;
    align-items: center;
  }

  :deep(.v-select__selection) {
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    line-height: 24px;
    display: flex;
    align-items: center;
  }

  :deep(.v-field__append-inner .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: #2E2E2E !important;
    opacity: 0.22;
  }
}

.filter-input {
  flex: 1 1 0;
  width: 100%;
  min-width: 0;
  max-width: 100%;

  :deep(.v-field) {
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    display: flex;
    align-items: center;
    margin: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  :deep(.v-field__input) {
    padding: 8px 16px;
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    min-height: auto;
    display: flex;
    align-items: center;
  }

  :deep(input::placeholder) {
    color: rgba(46, 46, 46, 0.5);
    font-weight: 400;
    font-family: "HarmonyOS Sans SC", sans-serif;
  }
}

.filter-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  height: 40px;
}

/* 值/备注长文本：固定列宽 + 省略号 + 悬停查看完整值 */
.value-cell {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

:global(.alert-value-tooltip) {
  max-width: 480px;
  line-height: 1.5;
  word-break: break-all;
}

/* 设备UUID：文本 + 复制按钮，按钮默认淡显，悬停行时高亮 */
.uuid-cell {
  display: flex;
  align-items: center;
  gap: 4px;

  .uuid-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .uuid-copy-btn {
    flex-shrink: 0;
    opacity: 0.45;
    transition: opacity 0.2s;
  }

  &:hover .uuid-copy-btn {
    opacity: 1;
  }
}

.alert-table-outer {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
}

/* 绝对定位隔离：让内部宽表格不影响外层 flex 链的宽度计算 */
.table-scroll {
  position: absolute;
  inset: 0 16px;
  overflow: auto;
}

.pm-table-sticky.v-table {
  width: 100%;
  min-width: max-content;
  background: transparent !important;

  :deep(.v-table__wrapper) {
    overflow: visible;
  }

  :deep(table) {
    width: 100%;
    min-width: max-content;
  }

  :deep(thead th) {
    white-space: nowrap;
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fff !important;
  }
}

.status-transferred {
  color: #3a68ff;
  font-weight: 400;
}

.status-unrecovered {
  color: #ff8a66;
  font-weight: 400;
}

.status-confirmed {
  color: #52C41A;
  font-weight: 400;
}

// 告警状态单元格：状态文字 + 人工确认按钮 + 详情按钮
.status-cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  .status-confirm-btn {
    height: 28px !important;
    min-height: 28px !important;
    padding: 0 10px !important;
    font-size: 13px !important;
  }
}

.analysis-btn {
  min-width: 88px !important;
  height: 32px !important;
  padding: 0 12px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  text-transform: none !important;

  :deep(.v-btn__content) {
    gap: 2px;
  }

  .vip-badge {
    font-size: 11px;
    font-weight: 700;
    color: #ffae00;
  }
}

// 人工确认弹窗（对齐业务配置样式）
.gm-dialog {
  :deep(.v-overlay__content) {
    border-radius: 30px !important;
  }
}

.dialog-card {
  border-radius: 30px !important;
  background: #fff;
}

.gm-dialog-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  position: relative;

  .text-h5 {
    font-size: 24px !important;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
}

.gm-btn-secondary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #545454 !important;
  box-shadow: none !important;
}

.gm-btn-primary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}

:deep(.v-input__details) {
  display: none;
}

// 高级筛选按钮激活样式
.action-btn--active {
  color: #fff !important;
}

// 高级筛选弹窗（右侧滑入）
.advanced-filter-card {
  height: 100vh;
  max-height: 100vh;
  border-radius: 30px 0 0 30px !important;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #fff;
}

.advanced-filter-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  flex-shrink: 0;

  .text-h5 {
    font-size: 24px !important;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
}

.advanced-filter-body {
  flex: 1 1 auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 0;
}

.advanced-filter-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.advanced-filter-label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.7);
}

.advanced-filter-actions {
  display: flex;
  flex-shrink: 0;
}

.advanced-filter-dialog :deep(.v-overlay__content) {
  margin: 0 !important;
  left: auto !important;
  right: 0 !important;
  width: min(420px, 100vw) !important;
  max-width: min(420px, 100vw) !important;
  height: 100% !important;
  max-height: 100% !important;
}

// 详情弹窗（对齐业务配置设备型号 新增弹窗样式）
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  margin: 12px 0 12px;
}

.pm-prop-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  overflow: hidden;

  thead th {
    background: #f8fafc;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 600;
    font-size: 14px;
    height: 44px;
    padding: 0 16px;
    text-align: left;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  tbody td {
    height: 48px;
    padding: 8px 16px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    word-break: break-all;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  .col-name {
    width: 35%;
  }

  .col-val {
    width: 65%;
  }
}

/* ============ 小屏 1366x768 兼容适配（对齐 待审批的电站 列表） ============ */
@media (max-width: 1440px) {
  .filter-bar {
    padding: 12px 16px !important;
    gap: 10px !important;
    flex-wrap: nowrap !important;

    .filter-item {
      flex: 1 1 0 !important;
      max-width: none !important;
      min-width: 0 !important;
    }

    .filter-actions {
      flex: 0 0 auto !important;
    }
  }

  .filter-label {
    font-size: 13px;
  }
}

@media (max-width: 1366px) {
  .filter-bar {
    padding: 10px 12px !important;
    gap: 8px !important;
    flex-wrap: nowrap !important;

    .filter-item {
      flex: 1 1 0 !important;
      max-width: none !important;
      min-width: 0 !important;
      gap: 6px !important;
    }

    .filter-actions {
      flex: 0 0 auto !important;
    }
  }

  .filter-label {
    font-size: 12px;
    flex-shrink: 0;
  }

  .alert-table-outer {
    padding: 0 12px !important;
  }

  .table-scroll {
    inset: 0 12px !important;
  }

  .status-cell {
    .status-confirm-btn {
      height: 26px !important;
      min-height: 26px !important;
      padding: 0 8px !important;
      font-size: 12px !important;
    }
  }
}

@media (max-height: 800px) {
  .filter-bar {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
    min-height: 0 !important;
  }
}
</style>

<style lang="scss">
.alert-management-filter-select-menu {
  border-radius: 10px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  margin-top: 4px !important;
  overflow: hidden !important;
  border: 1px solid rgba(224, 228, 231, 1) !important;

  .v-list {
    background: #fff !important;
    border-radius: 10px !important;
    padding: 4px 0 !important;

    .v-list-item {
      min-height: auto !important;
      padding: 8px 12px !important;
      color: rgba(46, 46, 46, 1) !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      line-height: 24px !important;
      transition: background-color 0.2s ease, color 0.2s ease !important;
      cursor: pointer !important;
      text-align: left !important;

      &:hover {
        background-color: #f5f7fa !important;
        color: rgba(58, 104, 255, 1) !important;
      }

      .v-list-item-title {
        font-family: 'PingFang SC', sans-serif !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        color: inherit !important;
        line-height: 24px !important;
      }
    }

    // 活动项样式（使用 active-class）
    .filter-select-active,
    .v-list-item--active {
      background-color: #f5f7fa !important;
      color: rgba(58, 104, 255, 1) !important;

      .v-list-item-title {
        color: rgba(58, 104, 255, 1) !important;
      }
    }
  }
}
</style>
